<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">프로모션 수정하기</p>

    <v-sheet class="mt-2 px-4">
      <v-text-field class="rounded-10" label="이름" dense outlined v-model.trim="updateItem.name"></v-text-field>
      <v-text-field class="rounded-10" label="코드" dense outlined v-model.trim="updateItem.code" readonly disabled></v-text-field>
      <!-- 상품 설정 -->
      <div class="font-weight-bold text-body-1 mb-4">상품 설정</div>
      <div v-if="updateItem.products && updateItem.products.length > 0" class="mb-4">
        <ProductCard v-for="(product, index) in updateItem.products" :key="product.id" :product="product" @edit="editProduct(index)" @delete="deleteProduct(index)" />
      </div>
      <v-alert v-else type="info" text class="mb-4"> 등록된 상품이 없습니다. 아래 버튼을 클릭하여 상품을 추가해주세요. </v-alert>
      <v-btn v-if="availableProductIds.length > 0" color="primary" outlined @click="showAddProductDialog" class="mb-8">
        <v-icon left>mdi-plus</v-icon>
        상품 추가
      </v-btn>

      <!-- 옵션 상품 설정 -->
      <div class="font-weight-bold text-body-1 mb-4">옵션 상품 설정</div>
      <div v-if="updateItem.optionProducts && updateItem.optionProducts.length > 0" class="mb-4">
        <v-chip v-for="product in updateItem.optionProducts" :key="product.id" class="ma-1" close @click:close="removeOptionProduct(product.id)">
          {{ getOptionProductTitle(product) }} ({{ product.price.toLocaleString() }}원)
        </v-chip>
      </div>
      <v-alert v-else type="info" text class="mb-4"> 선택된 옵션 상품이 없습니다. 아래 버튼을 클릭하여 옵션 상품을 추가해주세요. </v-alert>
      <v-btn color="success" outlined @click="showOptionProductDialog" class="mb-8">
        <v-icon left>mdi-plus</v-icon>
        옵션 상품 추가
      </v-btn>

      <v-select outlined dense :items="conceptList" item-text="title" item-value="id" v-model="updateItem.conceptId" label="컨셉" :key="'concept' + conceptComponentKey"></v-select>

      <div class="font-weight-bold text-body-1 py-2">프로모션 유효기간</div>
      <v-row>
        <v-menu v-model="openAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.openAt" label="링크시작일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.openAt" no-title scrollable color="green" @input="openAtMenu = false"></v-date-picker>
        </v-menu>
        <v-menu v-model="closeAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.closeAt" label="링크종료일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.closeAt" no-title scrollable color="warning" @input="closeAtMenu = false"> </v-date-picker>
        </v-menu>
      </v-row>

      <div class="font-weight-bold text-body-1 py-2">예약 가능 기간</div>
      <v-row>
        <v-menu v-model="startAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.startAt" label="예약 시작일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.startAt" no-title scrollable color="green" @input="startAtMenu = false"> </v-date-picker>
        </v-menu>
        <v-menu v-model="endAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.endAt" label="예약 종료일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.endAt" no-title scrollable color="warning" @input="endAtMenu = false"> </v-date-picker>
        </v-menu>
      </v-row>

      <!-- <div class="d-inline-block">
        <v-checkbox v-model="updateItem.enabled" class="shrink mt-4 ml-4" label="활성화 상태" color="primary" hide-details dense></v-checkbox>
      </div> -->

      <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear()">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="options" :key="componentKey" />
      </v-sheet>

      <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear('en')">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en-desc1' + en.componentKey" />
      </v-sheet>

      <div class="font-weight-bold text-h6 ml-4 mt-4">일본어</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear('jp')">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp-desc1' + jp.componentKey" />
      </v-sheet>

      <div class="d-inline-block">
        <v-checkbox v-model="updateItem.isIndividual" class="shrink mt-4 ml-0" label="개별 운영 (프리미엄)" color="primary" hide-details dense></v-checkbox>
      </div>

      <!-- 개별 운영시간 설정 -->
      <!-- <v-sheet v-if="updateItem.isIndividual" class="mt-4 pa-4" outlined>
        <div class="font-weight-bold text-h6 mb-4">개별 운영시간 설정</div>
        <div v-for="(item, index) in dayItems" :key="item" class="mb-4">
          <div class="font-weight-bold mb-2">{{ item }}</div>
          <WeekTimeComponent :key="'week-time' + index + componentKey" @change="(v) => setOperationTime(index, v)" :src="operationSettings[index]" />
        </div>
      </v-sheet> -->
    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="updateSubmit()">
        <v-icon small left>mdi-database-edit-outline</v-icon>
        수정하기
      </v-btn>
    </v-sheet>

    <!-- Product Edit Dialog -->
    <ProductEditDialog v-if="editingProduct" v-model="productEditDialog" :product="editingProduct" @save="onProductSave" />

    <!-- Option Product Select Dialog -->
    <v-dialog v-model="optionProductDialog" width="600" scrollable>
      <OptionProductSelectDialog v-model="optionProductDialog" :selected-products="updateItem.optionProducts" @toggle="toggleOptionProduct" />
    </v-dialog>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import WeekTimeComponent from "@/views/admin/operation_time/WeekTimeComponent"
import ProductEditDialog from "./ProductEditDialog.vue"
import ProductCard from "./ProductCard.vue"
import OptionProductSelectDialog from "./OptionProductSelectDialog.vue"

import { mapState } from "vuex"

export default {
  props: ["updateItem_import"],
  components: {
    TipTapWriter,
    WeekTimeComponent,
    ProductEditDialog,
    ProductCard,
    OptionProductSelectDialog,
  },
  inject: ["coupons_info", "concepts"],
  data: () => ({
    yesOrNo: ["Y", "N"],
    updateItem: {},

    startAtMenu: false,
    endAtMenu: false,
    openAtMenu: false,
    closeAtMenu: false,

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
    conceptComponentKey: 0,

    // 개별 운영시간 설정
    dayItems: ["월", "화", "수", "목", "금", "토", "일"],
    operationSettings: [[], [], [], [], [], [], []],
    existingOperationTimeId: null,

    // 그룹샷 초대 인원 수 옵션
    groupMemberItems: [
      { text: "2명", value: 2 },
      { text: "3명", value: 3 },
      { text: "4명", value: 4 },
      { text: "5명", value: 5 },
      { text: "6명", value: 6 },
    ],

    // Product edit dialog
    productEditDialog: false,
    editingProductIndex: -1,
    editingProduct: null,

    // Available product IDs
    allProductIds: ["option1", "option2", "option3", "option4", "option5", "option6"],

    // Option Product dialog
    optionProductDialog: false,
  }),

  computed: {
    availableProductIds() {
      const usedIds = this.updateItem.products ? this.updateItem.products.map((p) => p.id) : []
      return this.allProductIds.filter((id) => !usedIds.includes(id))
    },
    conceptList() {
      const filtered = this.concepts.filter((c) => {
        if (this.updateItem.isIndividual) {
          return c.productType === "premium"
        }
        return !c.productType || c.productType === "makershot"
      })
      return [{ title: "선택안함", id: null }, ...filtered]
    },
  },

  watch: {
    "updateItem.isIndividual"() {
      const selectedConcept = this.concepts.find((c) => c.id === this.updateItem.conceptId)
      if (selectedConcept) {
        const conceptType = selectedConcept.productType || "makershot"
        const expectedType = this.updateItem.isIndividual ? "premium" : "makershot"
        if (conceptType !== expectedType) {
          this.updateItem.conceptId = null
          this.conceptComponentKey++
        }
      }
    },
  },

  async mounted() {
    // 옵션 상품 정보 먼저 로드
    let optionProductsData = []
    if (this.updateItem_import.option_products) {
      try {
        const optionProductIds = this.updateItem_import.option_products.split(",").map((id) => id.trim())
        const response = await this.$http.get("/api/option-products/select")
        const allOptionProducts = response.data || []
        optionProductsData = allOptionProducts.filter((product) => optionProductIds.includes(product.id.toString()))
      } catch (error) {
        console.error("옵션 상품 로드 실패:", error)
      }
    }

    this.updateItem = {
      ...this.updateItem_import,

      openAt: this.updateItem_import.openAt ? this.dayjs(this.updateItem_import.openAt).format("YYYY-MM-DD") : null,
      closeAt: this.updateItem_import.closeAt ? this.dayjs(this.updateItem_import.closeAt).format("YYYY-MM-DD") : null,
      startAt: this.updateItem_import.startAt ? this.dayjs(this.updateItem_import.startAt).format("YYYY-MM-DD") : null,
      endAt: this.updateItem_import.endAt ? this.dayjs(this.updateItem_import.endAt).format("YYYY-MM-DD") : null,
      products: this.updateItem_import.products
        ? JSON.parse(this.updateItem_import.products).map((product) => ({
            ...product,
            freePicEditCount: product.freePicEditCount !== undefined ? product.freePicEditCount : 1,
          }))
        : [
            {
              id: "option1",
              price: this.updateItem_import.option1Price || 0,
              maxpersons: 1,
              type: "single",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 1,
            },
            {
              id: "option2",
              price: this.updateItem_import.option2Price || 0,
              maxpersons: 1,
              type: "single",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 2,
            },
            {
              id: "option3",
              price: this.updateItem_import.option3Price || 0,
              maxpersons: 2,
              type: "group",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 3,
            },
            {
              id: "option4",
              price: this.updateItem_import.option4Price || 0,
              maxpersons: 2,
              type: "group",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 4,
            },
            {
              id: "option5",
              price: this.updateItem_import.option5Price || 0,
              maxpersons: 3,
              type: "group",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 5,
            },
            {
              id: "option6",
              price: this.updateItem_import.option6Price || 0,
              maxpersons: 4,
              type: "group",
              freePicEditCount: 1,
              title: { kr: "", en: "", jp: "" },
              subtitle: { kr: "", en: "", jp: "" },
              order: 6,
            },
          ],
      optionProducts: optionProductsData,
    }
    this.options.content = this.updateItem.content
    this.en.options.content = this.updateItem.content_en
    this.jp.options.content = this.updateItem.content_jp

    this.componentKey++
    this.en.componentKey++
    this.jp.componentKey++

    // 개별 운영시간 정보 로드
    if (this.updateItem.isIndividual) {
      this.loadOperationTime()
    }

    console.log(this.updateItem)
  },

  methods: {
    showOptionProductDialog() {
      this.optionProductDialog = true
    },

    toggleOptionProduct(product) {
      const index = this.updateItem.optionProducts.findIndex((p) => p.id === product.id)
      if (index > -1) {
        this.updateItem.optionProducts.splice(index, 1)
      } else {
        this.updateItem.optionProducts.push(product)
      }
    },

    removeOptionProduct(productId) {
      const index = this.updateItem.optionProducts.findIndex((p) => p.id === productId)
      if (index > -1) {
        this.updateItem.optionProducts.splice(index, 1)
      }
    },

    getOptionProductTitle(product) {
      if (typeof product.title === "string") {
        try {
          const parsed = JSON.parse(product.title)
          return parsed.kr || product.title
        } catch {
          return product.title
        }
      } else if (product.title && typeof product.title === "object") {
        return product.title.kr || ""
      }
      return ""
    },

    showAddProductDialog() {
      const nextId = this.availableProductIds[0]
      if (!nextId) return

      const defaultPrices = {
        option1: this.updateItem_import.option1Price || 0,
        option2: this.updateItem_import.option2Price || 0,
        option3: this.updateItem_import.option3Price || 0,
        option4: this.updateItem_import.option4Price || 0,
        option5: this.updateItem_import.option5Price || 0,
        option6: this.updateItem_import.option6Price || 0,
      }

      this.editingProductIndex = -1 // -1 means adding new product
      this.editingProduct = {
        id: nextId,
        price: defaultPrices[nextId] || 0,
        maxpersons: nextId === "option1" || nextId === "option2" ? 1 : nextId === "option3" || nextId === "option4" ? 2 : nextId === "option5" ? 3 : 4,
        type: nextId === "option1" || nextId === "option2" ? "single" : "group",
        freePicEditCount: 1,
        title: { kr: "", en: "", jp: "" },
        subtitle: { kr: "", en: "", jp: "" },
        order: this.updateItem.products.length + 1,
      }
      this.productEditDialog = true
    },
    editProduct(index) {
      this.editingProductIndex = index
      this.editingProduct = JSON.parse(JSON.stringify(this.updateItem.products[index]))
      this.productEditDialog = true
    },
    onProductSave(updatedProduct) {
      if (this.editingProductIndex === -1) {
        // Adding new product
        this.updateItem.products.push(updatedProduct)
        // Sort by product ID order
        this.updateItem.products.sort((a, b) => {
          const orderA = this.allProductIds.indexOf(a.id)
          const orderB = this.allProductIds.indexOf(b.id)
          return orderA - orderB
        })
      } else {
        // Editing existing product
        this.updateItem.products[this.editingProductIndex] = updatedProduct
      }
    },
    deleteProduct(index) {
      if (confirm("이 상품을 삭제하시겠습니까?")) {
        this.updateItem.products.splice(index, 1)
        // Reorder remaining products
        this.updateItem.products.forEach((product, i) => {
          product.order = i + 1
        })
      }
    },
    clear(lang = "ko") {
      if (lang === "ko") {
        this.options.content = ""
        this.componentKey++
      } else if (lang === "en") {
        this.en.options.content = ""
        this.en.componentKey++
      } else if (lang === "jp") {
        this.jp.options.content = ""
        this.jp.componentKey++
      }
    },

    setOperationTime(index, value) {
      this.operationSettings[index] = value
    },

    async loadOperationTime() {
      try {
        const res = await this.$http.get(`/api/individual_operation_time/select/promotionCode`, {
          params: {
            promotionCode: this.updateItem.code,
          },
        })
        if (res.data && res.data.length > 0) {
          const info = res.data[0]
          this.existingOperationTimeId = info.id
          this.operationSettings[0] = info.mon ? info.mon.split(",").map((e) => e.trim()) : []
          this.operationSettings[1] = info.tue ? info.tue.split(",").map((e) => e.trim()) : []
          this.operationSettings[2] = info.wed ? info.wed.split(",").map((e) => e.trim()) : []
          this.operationSettings[3] = info.thu ? info.thu.split(",").map((e) => e.trim()) : []
          this.operationSettings[4] = info.fri ? info.fri.split(",").map((e) => e.trim()) : []
          this.operationSettings[5] = info.sat ? info.sat.split(",").map((e) => e.trim()) : []
          this.operationSettings[6] = info.sun ? info.sun.split(",").map((e) => e.trim()) : []
          this.componentKey++
        }
      } catch (e) {
        console.log("개별 운영시간 로드 실패:", e)
      }
    },

    // 목록
    updateSubmit: _.debounce(async function () {
      // 제목 검증
      // if (this.updateItem.name == "") {
      //   alert("이름을 입력해주세요")
      //   return
      // }

      // 컨셉소개 내용 검증
      if (this.updateItem.code == "") {
        alert("프로모션 코드를 입력해주세요")
        return
      }

      // 가격 검증
      const hasInvalidPrice = this.updateItem.products.some((product) => product.price < 0)
      if (hasInvalidPrice) {
        alert("유효한 가격 정보를 입력해주세요")
        return
      }

      if (!this.updateItem.endAt) {
        alert("종료일자를 입력해주세요")
        return
      }

      this.$http
        .post("/api/promotion/update", {
          params: {
            code: this.updateItem.code,
            name: this.updateItem.name,
            option1Price: Number(this.updateItem.products.find((p) => p.id === "option1")?.price || 0),
            option2Price: Number(this.updateItem.products.find((p) => p.id === "option2")?.price || 0),
            option3Price: Number(this.updateItem.products.find((p) => p.id === "option3")?.price || 0),
            option4Price: Number(this.updateItem.products.find((p) => p.id === "option4")?.price || 0),
            option5Price: Number(this.updateItem.products.find((p) => p.id === "option5")?.price || 0),
            option6Price: Number(this.updateItem.products.find((p) => p.id === "option6")?.price || 0),
            products: JSON.stringify(this.updateItem.products),
            conceptId: this.updateItem.conceptId,
            enabled: this.updateItem.enabled,
            openAt: this.updateItem.openAt,
            closeAt: this.updateItem.closeAt,
            startAt: this.updateItem.startAt,
            endAt: this.updateItem.endAt,
            description: this.options.content,
            description_en: this.en.options.content,
            description_jp: this.jp.options.content,
            isIndividual: this.updateItem.isIndividual,
            optionProducts: this.updateItem.optionProducts.length > 0 ? this.updateItem.optionProducts.map((p) => p.id).join(",") : null,
            id: this.updateItem.id,
          },
        })
        .then(async (res) => {
          if (res) {
            // 개별 운영시간 설정 처리
            if (this.updateItem.isIndividual) {
              try {
                const operationData = {
                  promotionCode: this.updateItem.code,
                  mon: this.operationSettings[0].length > 0 ? this.operationSettings[0].join(",") : "",
                  tue: this.operationSettings[1].length > 0 ? this.operationSettings[1].join(",") : "",
                  wed: this.operationSettings[2].length > 0 ? this.operationSettings[2].join(",") : "",
                  thu: this.operationSettings[3].length > 0 ? this.operationSettings[3].join(",") : "",
                  fri: this.operationSettings[4].length > 0 ? this.operationSettings[4].join(",") : "",
                  sat: this.operationSettings[5].length > 0 ? this.operationSettings[5].join(",") : "",
                  sun: this.operationSettings[6].length > 0 ? this.operationSettings[6].join(",") : "",
                }

                if (this.existingOperationTimeId) {
                  // 기존 데이터 업데이트
                  await this.$http.post("/api/individual_operation_time/update", {
                    ...operationData,
                    id: this.existingOperationTimeId,
                  })
                } else {
                  // 새로운 데이터 생성
                  await this.$http.post("/api/individual_operation_time/insert", operationData)
                }
              } catch (e) {
                console.log("개별 운영시간 저장 실패:", e)
              }
            } else if (this.existingOperationTimeId) {
              // isIndividual false로 변경된 경우 기존 데이터 삭제
              try {
                await this.$http.post("/api/individual_operation_time/delete", {
                  id: this.existingOperationTimeId,
                })
                this.existingOperationTimeId = null
              } catch (e) {
                console.log("개별 운영시간 삭제 실패:", e)
              }
            }

            alert("정상적으로 수정되었습니다.")
            this.$emit("close")
          } else {
            alert("등록되지 않았습니다")
          }
        })
        .catch((e) => {
          console.log(e)
          // 원인을 알 수 있도록 서버가 돌려준 메시지를 함께 보여준다
          const status = e.response?.status
          const message = e.response?.data?.message
          if (status === 413) {
            alert("설명 내용이 너무 커서 저장하지 못했습니다. 설명의 분량을 줄여 다시 시도해주세요.")
          } else if (message) {
            alert(this.$t("alert.error_page") + "\n(" + (status || "") + ") " + message)
          } else {
            alert(this.$t("alert.error_page"))
          }
        })
    }, 500),
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
